import styled from "styled-components";

export const SettingsHeading = styled.h4`
  margin-top: 10px;
  margin-bottom: 10px;
`;
